<div class="payment-sip-upi">

  <app-tutorial *ngIf="config?.showTutorial" tutorialUrl="https://www.youtube.com/embed/ShcccnQ0884" title="UPI Autopay Tutorial"
                text="How upi autopay works?" eventName="how_upi_autopay_works">
  </app-tutorial>

  <div *ngIf="config.showUpiIntent">
    <app-payment-sip-upi-intents [config]="config" (dataEmit)="dataEmit.emit($event)"></app-payment-sip-upi-intents>
  </div>


  <form *ngIf="!vars.isAgent" [formGroup]="upiForm">
    <mat-form-field class="input-field" [appearance]="config?.inputAppearance">
      <mat-label>Enter your UPI ID</mat-label>
      <input type="text" [formControl]="upiInputControl" (input)="verified=false" [matAutocomplete]="auto" (blur)="onInputBlur()" matInput>

      <div class="upi-loading" *ngIf="upiInputControl?.valid">
        <mat-spinner *ngIf="isLoading" diameter="20" strokeWidth="2"></mat-spinner>
        <!-- <svg *ngIf="!isLoading && verified" class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg> -->
      </div>

      <mat-error *ngIf="!config?.one_time_donation && upiInputControl?.invalid && upiInputControl?.touched">Please use valid AmazonPay/Gpay/Paytm/PhonePe UPI ID</mat-error>
      <mat-error *ngIf="config?.one_time_donation && upiInputControl?.invalid && upiInputControl?.touched">Please use valid UPI ID</mat-error>

      <mat-autocomplete [hidden]="!upiInputControl?.value?.match('@')" autoActiveFirstOption (optionSelected)="verifyUpi(upiInputControl?.value)" #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="upiInputControl?.value?.split('@')[0] + '@' + option">
          {{upiInputControl?.value?.split('@')[0] + '@' + option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>

  <app-upi-input [isSip]="true" *ngIf="vars.isAgent" [recommendedVpa]="checkPrefillUPI" [cartDetails]="sessionCart?.cart" [disableAll]="vars.upiTimer && showTime ? true : false" [isOrderLoading]="paymentV2.isOrderLoading" (onSubmit)="upiInputSubmit($event)"/>

</div>

<app-payment-sip-upi-timer *ngIf="vars.upiTimer && showTime"></app-payment-sip-upi-timer>